import { useRef } from 'react';
import { usePersistentCallback } from '../hooks';
export const useSilenceDetection = (silenceThreshold, silenceTimeoutDuration, onSilenceDetected) => {
    const silenceTimeoutRef = useRef(null);
    const silenceDetectedRef = useRef(false);
    const detectSilence = usePersistentCallback((analyserNode) => {
        if (!analyserNode)
            return;
        const bufferLength = analyserNode.fftSize;
        const dataArray = new Uint8Array(bufferLength);
        const detectSilence = () => {
            analyserNode.getByteTimeDomainData(dataArray);
            let isSilent = true;
            // Calculate the average volume level
            for (let i = 0; i < bufferLength; i++) {
                if (Math.abs(dataArray[i] - 128) / 128 > silenceThreshold) {
                    isSilent = false;
                    break;
                }
            }
            if (isSilent) {
                if (!silenceDetectedRef.current) {
                    silenceDetectedRef.current = true;
                    silenceTimeoutRef.current = setTimeout(() => {
                        if (silenceDetectedRef.current) {
                            onSilenceDetected();
                        }
                    }, silenceTimeoutDuration);
                }
            }
            else {
                silenceDetectedRef.current = false;
                if (silenceTimeoutRef.current) {
                    clearTimeout(silenceTimeoutRef.current);
                }
            }
            // Continue checking silence
            requestAnimationFrame(detectSilence);
        };
        detectSilence();
    });
    const stopSilenceDetection = usePersistentCallback(() => {
        if (silenceTimeoutRef.current) {
            clearTimeout(silenceTimeoutRef.current);
        }
    });
    return { detectSilence, stopSilenceDetection };
};
